/// <amd-module name="Artifacts/FeedSettings/types/IFeedRetentionSettings" />
export interface IFeedRetentionSettings {
  /**
   * User configured limit for the number of days to keep recently downloaded packages
   */
  daysToKeepRecentPackages?: number;
  /**
   * Default count of package versions to keep
   */
  defaultCountLimit: number;
  /**
   * Default limit for the number of days to keep recently downloaded packages
   */
  defaultDaysToKeepLimit: number;
  /**
   * Is retention policy enabled
   */
  isEnabled: boolean;
  /**
   * Maximum count of package versions to keep
   */
  maximumCountLimit: number;
  /**
   * Maximum limit for the number of days to keep recently downloaded packages
   */
  maximumDaysToKeepLimit: number;
  /**
   * Minimum count of package versions to keep
   */
  minimumCountLimit: number;
  /**
   * Minimum limit for the number of days to keep recently downloaded packages
   */
  minimumDaysToKeepLimit: number;
  /**
   * User configured count limit for package versions
   */
  packageVersionCountLimit?: number;
}
